module.exports = __webpack_public_path__ + "static/we-are-makook-acedf41e3fcf812eae2444b48ae10e87.mp4";